/**
 * User saved searches
 */

import { UserSavedSearch } from '../../types/userSavedSearch.types';
import { dispatch } from '..';
import { USER_SAVED_SEARCHES_SET } from '../action-types/user-saved-searches.action-types';

export const saveUserSearches = (data: UserSavedSearch[]) => dispatch({ type: USER_SAVED_SEARCHES_SET, data });
